<template>
    <window ref="window"   
        size="full" 
        title="Meldungen von Monteuren"
        @closed="onClosed">

        <messages :data-src="messages" base-class="job-messages">
            <template slot="message" slot-scope="{ message }">
                <job-message :message="message" base-class="job-messages__message"></job-message>
            </template>
        </messages>
    </window>
</template>

<script>
import JobMessage from '../views/Job/JobMessage';

export default {
    components: {
        'job-message': JobMessage
    },
    provide: {
        windowId: 'jobMessages'
    },
    props: {
        messages: {
            type: Array,
            required: true
        }
    },
    methods: {
        onClosed() {
            for(const message of this.messages) {
                if(message.data && 'pictures' in message.data) {
                    for(const picture of message.data.pictures) {
                        if('src' in picture.file && picture.file.src) {
                            URL.revokeObjectURL(picture.file.src);
                            picture.file.src = null;
                        }
                    }
                }
            }
        }
    }
}
</script>